import { render, staticRenderFns } from "./mountRaisedModal.vue?vue&type=template&id=4ff704be&scoped=true&"
import script from "./mountRaisedModal.vue?vue&type=script&lang=js&"
export * from "./mountRaisedModal.vue?vue&type=script&lang=js&"
import style0 from "./mountRaisedModal.vue?vue&type=style&index=0&id=4ff704be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff704be",
  null
  
)

export default component.exports